// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { FunctionalComponent, h } from '@stencil/core';

import NoFollowLink from './NoFollowLink';
import { FormattedPromotion } from '../../types';
import showTerms from '../../utils/terms';

interface PromotionCardProps {
    promotion: FormattedPromotion | null;
    logPromotionClick: () => void;
    handleBonusCodeClick?: () => void;
    handleBonusCopyClick?: () => void;
    bonusCodeWasClicked?: boolean;
    useBoxShadow?: boolean;
    promoValidDate?: string;
    terms?: 'geo' | 'affiliate';
    reveal?: string;
    revealText?: string;
    bonusOpen?: boolean;
    buttonText?: string;
    handleTermsClick?: () => void;
    termsToggle?: boolean;
}

const BonusPromotionCardBanner: FunctionalComponent<PromotionCardProps> = ({
    promotion,
    logPromotionClick,
    useBoxShadow = false,
    reveal = 'false',
    revealText = 'Reveal Code',
    handleBonusCodeClick,
    terms,
    buttonText,
    handleTermsClick,
    termsToggle = false,
}) => {
    if (reveal === 'animated' && revealText === 'Reveal Code') {
        revealText = 'Reveal Bonus Code'; // Default value for revealText is different on animated
    }

    const termsText = promotion ? showTerms(promotion, terms) : '';

    let shortTerms = '';
    let showShortTerms = false;
    if (termsText.length > 140) {
        shortTerms = `${termsText.slice(0, 140)}...`;
        showShortTerms = true;
    }

    const codeClick = () => {
        logPromotionClick();
        handleBonusCodeClick();
    };

    const handleThisTermsClick = () => {
        if (handleTermsClick) {
            handleTermsClick();
        }
    };

    const propMarfeelConversion = promotion?.link && promotion?.link.includes('switchboard') ? 'switchboard-click' : '';

    return (
        <div class="bonus-component__banner">
            <div>
                {promotion ? (
                    <lazy-load-logo
                        class="large__logo"
                        logo={promotion.logo}
                        promoId={promotion.id}
                        logoColor={promotion.logoColor}
                        width={60}
                        height={60}
                    />
                ) : (
                    <div class="skeleton-item__logo"></div>
                )}
            </div>
            <div class="bonus-component__cta-container">
                <div class="bonus-component__banner-info">Welcome Bonus</div>
                <div class="bonus-component__banner-cta">{promotion.cta.trim()}</div>
                <div class="bonus-component__terms">
                    {!termsToggle && showShortTerms && (
                        <div class="item__terms">
                            {shortTerms}
                            <span class="item__terms-seemore" onClick={handleThisTermsClick}>
                                See More
                            </span>
                        </div>
                    )}
                    {(termsToggle || !showShortTerms) && <div class="item__terms">{termsText}</div>}
                </div>
            </div>

            <div class="bonus-component__buttons-container">
                <NoFollowLink
                    class={useBoxShadow ? `item item__shadow font no-decoration` : `item font no-decoration`}
                    onClick={codeClick}
                    href={promotion?.link}
                >
                    <div class="bonus-component__banner-buttons">
                        <div class="bonus-component__code-container">
                            <button class="bonus-component__bonus">
                                <div style={{ width: '100%' }}>
                                    <div class="bonus-component__bonus-code banner-bonus">
                                        {promotion?.bonusCode || 'NO CODE NEEDED'}
                                    </div>
                                    <div class="bonus-component__bonus-label banner-bonus-label">Promo Code</div>
                                </div>
                            </button>
                        </div>

                        <button class="bonus-component__claim" data-mrf-conversion={propMarfeelConversion}>
                            {buttonText || promotion?.buttonText || `Claim ${promotion.bookName} Promo`}
                        </button>
                    </div>
                </NoFollowLink>
            </div>
        </div>
    );
};

export default BonusPromotionCardBanner;
